import React, {createElement, useEffect, useState} from 'react';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import Style from './index.module.scss';
import axios from 'axios';
import qs from 'qs'

export interface LayoutComponentProps {
    style?: object;
    width?: number;
    isCenter?: boolean;
    children?: any;
    nodeId: string
    __designMode: string;
}

const LayoutComponent: React.FC<LayoutComponentProps> = (props) => {
    const { style, width, isCenter, children, __designMode, nodeId } = props;
    const [ isEditing, setIsEditing  ] = useState(false)
    const [ isShowMask, setIsShowMask ] = useState(false)
    const [ isShowInData, setIsShowInData ] = useState(false) // 在通栏数据里是否显示

    useEffect(() => {
        setIsEditing(location.pathname.includes('/visualediting') || (location.pathname.includes('/preview')))
        setIsShowInData(!window.allData?.layoutData?.includes(nodeId))
    }, [])

    const handleShowCheck = async (e) => {
        const newList = [...window.allData?.layoutData]
        if (isShowInData) {
            newList.push(nodeId)
        } else {
            newList.splice(newList.findIndex(a => a === nodeId),  1)
        }

        try {
            const res = await axios.post('https://ucms.ifeng.com/platform/lowcode/lowcodeApi/lowcode/tonglan/page/update', qs.stringify({
                'page_id': window.allData.page_id,
                'data': JSON.stringify(newList)
            }), {
                withCredentials: true
            })

            if (res.data.code === 0) {
                if (window.allData) {
                    window.allData.layoutData = newList
                }
                setIsShowInData(!newList.includes(nodeId))
                alert(`修改成功，2分钟后生效。\n如果想继续修改，不要刷新页面，否则可能会命中缓存页面，导致数据错乱`)
            } else {
                alert(res.message)
            }
        } catch (e) {
            console.log(e)
            alert('请先登录 umcs')
        }
    }

    if (!isShowInData && __designMode !== 'design' && !isEditing) {
        return null
    }

    return (
        <div id={nodeId} style={{ position: 'relative', width: `${width}px`, margin: isCenter ? '0 auto' : '', boxSizing: 'border-box', ...style }}>
            {children}
            {
                (__designMode === 'design' || isEditing) &&
                <Mask visible={!__designMode && !isShowInData} zIndex={3} contentStyle={{ backgroundColor: 'rgba(255, 0, 0, 0.15)' }}>
                    已隐藏
                </Mask>
            }
            {
                isEditing &&
                <div>
                    <div data-isshowcheck={true} className={`${Style.ShowCheck} ${isShowInData ? Style.showed : ''}`} onClick={handleShowCheck} onMouseEnter={() => setIsShowMask(true)} onMouseLeave={() => setIsShowMask(false)}>
                        {
                            isShowInData ? '已显示' : '已隐藏'
                        }
                    </div>
                    <div className={`${Style.ShowCheckMask} ${isShowInData ? Style.showed : ''} ${isShowMask ? Style.show : ''}`} />
                </div>
            }
        </div>
    );
};

export default LayoutComponent;
